import { BasicButton } from "@certn/cascadia";
import {
  Container,
  Grid,
  Layout,
  SecondaryTopNav,
} from "@certn/cascadia-react";
import { PrimaryButton, Text } from "@certn/cascadia";
import { t } from "i18next";
import { PropsWithChildren, useState } from "react";
import { CancelModal } from "../check-arguments-templates-shared";

interface TemplateLayoutProps extends PropsWithChildren {
  type: "create" | "update";
  title: string;
  hideCancelModal?: boolean;
  disableCompletion?: boolean;
  submitting?: boolean;
  onComplete?: () => void;
  onCancel: () => void;
}

export function TemplateLayout({
  type,
  title,
  hideCancelModal = false,
  disableCompletion,
  submitting,
  onComplete,
  children,
  onCancel,
}: TemplateLayoutProps) {
  const [showCancelModal, setShowCancelModal] = useState(false);

  const handleCancel = () => {
    setShowCancelModal(false);
    onCancel();
  };

  return (
    <Layout
      layout="narrow"
      header={
        <SecondaryTopNav
          testID="close-button"
          leftIcon="close"
          onleftIconOnPress={() => {
            if (hideCancelModal) {
              onCancel();
            } else {
              setShowCancelModal(true);
            }
          }}
        >
          {!hideCancelModal && (
            <BasicButton
              onPress={() => setShowCancelModal(true)}
              isLoading={submitting}
              testID={"cancel-button"}
            >
              {t("Cancel")}
            </BasicButton>
          )}
          <PrimaryButton
            onPress={() => onComplete?.()}
            isDisabled={disableCompletion}
            isLoading={submitting}
          >
            {type === "create" ? t("Save template") : t("Save changes")}
          </PrimaryButton>
        </SecondaryTopNav>
      }
    >
      <Container>
        <Text as="h1" style="global/title-medium">
          {title}
        </Text>

        <Grid form>{children}</Grid>
        {!hideCancelModal && showCancelModal && (
          <CancelModal
            onConfirm={handleCancel}
            onClose={() => setShowCancelModal(false)}
            isOpen={showCancelModal}
          />
        )}
      </Container>
    </Layout>
  );
}
